import { render, staticRenderFns } from "./noconnection.vue?vue&type=template&id=a8909c04&"
import script from "./noconnection.vue?vue&type=script&lang=js&"
export * from "./noconnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports